module.exports = __webpack_public_path__ + "static/media/platzhalter_produkt.e399d8b2.jpg";